import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DefaultResponse } from '../_core/state/session';
import { QueryParams } from '../_core/state/collection/collection.model';

/**
 * This is the base service for most
 */
export class LocalStorageMockService {

  	constructor(
		public key: string = 'data'
	) { }

	/**
	 * Returns a list of all Entities
	 */
	get(params: QueryParams): Observable<DefaultResponse<any>> {
		let data = localStorage.getItem(this.key);
		if (data) {
			return new Observable(observer => {
				observer.next({
					message: 'suceess',
					data: JSON.parse(data),
					status: 'success',
					totalResults: 1
				});
				observer.complete();
			});
		} else {
			return new Observable(observer => {
				observer.next({
					message: 'suceess',
					data: [],
					status: 'success',
					totalResults: 0
				});
				observer.complete();
			});
		}
	};

	add(newItem: string) {
		let data = localStorage.getItem(this.key);
		if (data) {
			let parsedData = JSON.parse(data);
			let newData = [
				...parsedData,
				newItem
			];

			localStorage.setItem(this.key, JSON.stringify(newData));

			return new Observable(observer => {
				observer.next({
					message: 'suceess',
					data: newData,
					status: 'success',
					totalResults: 1
				});
				observer.complete();
			});
		}
	}

	upsert(id: string, updatedItem: any): Observable<DefaultResponse<any>> {
		let data = localStorage.getItem(this.key) || '[]';
		let parsedData = JSON.parse(data);
		let existingItem = parsedData.find(item => item.id === id);
		let newData = parsedData.filter(item => item.id !== id);

		console.log(id, updatedItem, existingItem, newData);

		if (existingItem) {
			newData = [
				...newData,
				updatedItem
			];
		} else {
			newData = [
				...newData,
				updatedItem
			];
		}

		localStorage.setItem(this.key, JSON.stringify(newData));

		return new Observable(observer => {
			observer.next({
				message: 'suceess',
				data: newData,
				status: 'success',
				totalResults: 1
			});
			observer.complete();
		});

	}

	remove(id: string) {
		let data = localStorage.getItem(this.key);
		if (data) {
			let parsedData = JSON.parse(data);
			let newData = parsedData.filter(item => item.id !== id);

			localStorage.setItem(this.key, JSON.stringify(newData));

			return new Observable(observer => {
				observer.next({
					message: 'suceess',
					data: newData,
					status: 'success',
					totalResults: 1
				});
				observer.complete();
			});
		} else {
			return new Observable(observer => {
				observer.next({
					message: 'suceess',
					data: [],
					status: 'success',
					totalResults: 0
				});
				observer.complete();
			});
		}
	}

}
